"use client";
import { Translate } from "@/components/Translate";
import { useFormContext } from "react-hook-form";
import styles from "./Account.module.css";
import type { StoryblokRichtext } from "@/storyblok-base";
import { RichTextRender } from "@/components/ui/RichTextRender";
import { useTranslations } from "@/i18n/client";

export const NewsletterCheckbox = ({
	signupTerms,
	signupLabel,
	showError = true,
	termsClassName,
}: {
	signupTerms?: StoryblokRichtext | undefined;
	signupLabel?: string;
	showError?: boolean;
	termsClassName?: string;
}) => {
	const t = useTranslations();
	const {
		register,
		formState: { errors },
	} = useFormContext();

	return (
		<div>
			<div className={styles.checkboxContainer}>
				<input
					type="checkbox"
					id="newsletter"
					{...register("newsletter")}
					className={styles.checkboxInput}
				/>
				<label htmlFor="newsletter" className={styles.checkboxLabel}>
					{signupLabel ?? t("Subscribe to our newsletter")}
				</label>
			</div>
			{signupTerms && (
				<RichTextRender
					blok={signupTerms}
					preview={true}
					className={termsClassName || styles.signUpTerms}
				/>
			)}
			{showError && errors.newsletter && (
				<span className={styles.checkboxError}>{errors.newsletter.message as string}</span>
			)}
		</div>
	);
};
